import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { CTAButton } from '../ui/CTAButton';
export function FinalCTA() {
  return <section className="py-24 bg-beige relative overflow-hidden" data-id="element-27">
      <div className="absolute inset-0 opacity-10 pointer-events-none" style={{
      backgroundImage: 'radial-gradient(#1B2A4A 1px, transparent 1px)',
      backgroundSize: '30px 30px'
    }} data-id="element-28"></div>

      <div className="container mx-auto px-4 max-w-3xl relative z-10 text-center" data-id="element-29">
        <FadeIn data-id="element-30">
          <h2 className="text-4xl md:text-5xl font-bold text-navy mb-4 font-serif" data-id="element-31">
            Tu primera canción está más cerca de lo que creés
          </h2>
          <p className="text-xl text-navy/80 mb-4" data-id="element-32">
            No dejes pasar más tiempo. El mejor momento para empezar fue ayer,
            el segundo mejor momento es hoy.
          </p>
          <p className="text-lg text-navy/60 italic mb-12" data-id="element-33">
            Disfrutá tocar piano sin presión, a tu ritmo y desde tu casa.
          </p>

          <CTAButton className="py-5 px-10 text-xl shadow-xl" data-id="element-34">
            QUIERO TOCAR MI PRIMERA CANCIÓN
          </CTAButton>
          <p className="text-sm text-navy/50 mt-4" data-id="element-35">
            Acceso inmediato – empezás hoy mismo
          </p>
        </FadeIn>
      </div>
    </section>;
}